import { forwardRef } from "react";
import SignatureCanvas from "react-signature-canvas";

export const SignaturePad = forwardRef(({ testId }, ref) => (
  <div className="border border-white/15 bg-white" data-testid={testId}>
    <SignatureCanvas
      ref={ref}
      penColor="#0a1526"
      backgroundColor="#ffffff"
      canvasProps={{ className: "w-full h-40", "aria-label": "Draw signature" }}
    />
  </div>
));

SignaturePad.displayName = "SignaturePad";
